// extracted by mini-css-extract-plugin
export default {"container":"box-preview_container__qfdBE"};